import { render, staticRenderFns } from "./PortalApp.vue?vue&type=template&id=33039b5a&lang=pug"
import script from "./PortalApp.vue?vue&type=script&lang=ts"
export * from "./PortalApp.vue?vue&type=script&lang=ts"
import style0 from "./PortalApp.vue?vue&type=style&index=0&id=33039b5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports